/**
 * Critères de conformité EGAlim, dans l'ordre d'affichage de la jauge yo-indicateur-egalim
 * (valeurs, palette et légende suivent ce même ordre).
 */
export enum CritereEgalimEnum {
  PRODUITS_DURABLES = "PRODUITS_DURABLES",
  BIO = "BIO",
  POISSON_VIANDE_DURABLE = "POISSON_VIANDE_DURABLE"
}
